module.exports = __webpack_public_path__ + "img/start-4.a50e2d62.png";